import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=4f499d74&scoped=true"
import script from "./Attribute.vue?vue&type=script&lang=ts"
export * from "./Attribute.vue?vue&type=script&lang=ts"
import style0 from "./Attribute.vue?vue&type=style&index=0&id=4f499d74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f499d74",
  null
  
)

export default component.exports